import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { MapPin } from "lucide-react";
import { CarrierFormData, usStates } from "./CarrierSignup";

interface Props {
  handleArrayToggle: (field: keyof CarrierFormData, value: string) => void;
  formData: CarrierFormData;
}

const specializations = [
  "Temperature Controlled",
  "Hazardous Materials",
  "Oversized Loads",
  "Expedited Delivery",
  "White Glove Service",
  "Cross Docking",
  "LTL (Less Than Truckload)",
  "Intermodal",
  "Dedicated Routes",
  "Last Mile Delivery",
];

export function ServiceAreaAndSpecializations({
  formData,
  handleArrayToggle,
}: Props) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="h-5 w-5" />
            Service Areas
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Label>States You Operate In *</Label>
          <div className="grid grid-cols-5 gap-2 mt-2 max-h-48 overflow-y-overflow">
            {usStates.map((state) => (
              <label key={state} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={formData.serviceStates.includes(state)}
                  onChange={() => handleArrayToggle("serviceStates", state)}
                  className="rounded border-gray-300"
                />
                <span className="text-sm">{state}</span>
              </label>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Specializations</CardTitle>
        </CardHeader>
        <CardContent>
          <Label>Service Specializations</Label>
          <div className="grid grid-cols-1 gap-2 mt-2">
            {specializations.map((spec) => (
              <label key={spec} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  checked={formData.specializations.includes(spec)}
                  onChange={() => handleArrayToggle("specializations", spec)}
                  className="rounded border-gray-300"
                />
                <span className="text-sm">{spec}</span>
              </label>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
